import { createFileRoute } from '@tanstack/react-router';
import messages from 'app/_authenticated/funds/messages';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import BankDepositPOPComponent from './components/BankDepositPOP';

export const Route = createFileRoute('/_authenticated/funds/deposit/fiat/bank/pop')({
  component: BankDepositPOP,
});

function BankDepositPOP() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page={`/funds/deposit/fiat/bank/pop`}
      />
      <div className="px-6 py-4">
        <BankDepositPOPComponent />
      </div>
    </>
  );
}
